// Backend keys from permissions.json → Communication → WhatsAppSettings (premium plan).
export const WHATSAPP_SETTINGS_PERMISSIONS = {
  read: "Communication.WhatsAppSettings.read",
  manage: "Communication.WhatsAppSettings.manage",
} as const;

// Backend keys from permissions.json → Communication → WhatsAppAutomation (premium plan).
// `read` was added in phase 3C for the delivery-log/status read surface.
export const WHATSAPP_AUTOMATION_PERMISSIONS = {
  read: "Communication.WhatsAppAutomation.read",
  send: "Communication.WhatsAppAutomation.send",
  bulkSend: "Communication.WhatsAppAutomation.bulkSend",
} as const;

// Templates read/manage gate the WhatsApp Templates tab (phase 3A's WhatsAppTemplatesController).
export const WHATSAPP_TEMPLATES_PERMISSIONS = {
  read: "Communication.Templates.read",
  manage: "Communication.Templates.manage",
} as const;
